import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-readiness',
  templateUrl: './readiness.component.html',
  styleUrls: ['./readiness.component.css']
})
export class ReadinessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
